import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const ONBOARDING_KEY = 'zenermind_has_seen_onboarding';

const onboardingSteps = [
  {
    title: 'Nasıl Çalışır',
    description: 'Sezgisel algınıza dayanarak bir sembol seçersiniz. Sistem, önceden oluşturulmuş diziden bir sonraki kartı açar.'
  },
  {
    title: 'Önceden Oluşturulmuş Adalet',
    description: 'Kartlar oturumun başında oluşturulur, seçim yaptığınız anda değil. Bu, adalet ve tutarlılığı korur.'
  },
  {
    title: 'Sakin Tempo',
    description: 'Hızlı tahmin yapmaktan kaçının. Algının yol göstermesine izin verin. Tekrarlanan oturumlar istikrar oluşturur.'
  }
];

export const Onboarding = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  
  const handleNext = () => {
    if (currentStep < onboardingSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleComplete();
    }
  };
  
  const handleComplete = () => {
    localStorage.setItem(ONBOARDING_KEY, 'true');
    onComplete();
  };
  
  const step = onboardingSteps[currentStep];
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(5, 5, 5, 0.95)' }} data-testid="onboarding-overlay">
      <motion.div
        className="glass-panel max-w-md w-full p-8 space-y-6 relative"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        {/* Close button */}
        <button
          onClick={handleComplete}
          className="absolute top-4 right-4 text-slate-500 hover:text-slate-300 transition-colors"
          data-testid="onboarding-close-btn"
        >
          <X className="w-5 h-5" />
        </button>
        
        {/* Content */}
        <div className="space-y-4">
          <div className="text-center space-y-2">
            <p className="text-xs tracking-widest uppercase text-cyan-400 font-medium">
              Adım {currentStep + 1} / {onboardingSteps.length}
            </p>
            <h2 className="text-2xl font-heading text-slate-100">
              {step.title}
            </h2>
          </div>
          
          <p className="text-slate-400 text-center leading-relaxed">
            {step.description}
          </p>
        </div>
        
        {/* Navigation */}
        <div className="flex items-center justify-between pt-4">
          <div className="flex gap-2">
            {onboardingSteps.map((_, index) => (
              <div
                key={index}
                className={`h-1.5 w-8 rounded-full transition-colors ${
                  index === currentStep ? 'bg-violet-400' : 'bg-white/10'
                }`}
              />
            ))}
          </div>
          
          <button
            onClick={handleNext}
            className="rounded-full bg-white/5 px-6 py-2 text-sm font-medium text-white transition-all hover:bg-white/10 border border-white/10"
            data-testid="onboarding-next-btn"
          >
            {currentStep < onboardingSteps.length - 1 ? 'İleri' : 'Başla'}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export const hasSeenOnboarding = () => {
  return localStorage.getItem(ONBOARDING_KEY) === 'true';
};
